import { useQuery } from "../../Utils/utils"

export const useRequestsPageQuery = (search) => {
  const query = useQuery(search)
  return {
    folder: query.get("folder"),
    addCommentRequestID: query.get("add_comment")
  }
}
